// extracted by mini-css-extract-plugin
export default {"block":"ServiceBlock_block__Wuczm","selected":"ServiceBlock_selected__juM81"};